import Bowser from "bowser"
import queryString from 'query-string'
import {subdomainResource, apiHost, apiProtocol} from './url' 

const browser = Bowser.getParser(window.navigator.userAgent).getBrowser()

export function createPublicPost (name, options) {
  return createPost('public', name, options)
}

export function requestPDF(filename, html) {
  const req = new XMLHttpRequest()
  req.open("POST", '//' + subdomainResource(apiHost,'pdf'), true)
  req.setRequestHeader('Content-Type','application/json')
  req.responseType = 'blob'
  req.onreadystatechange = () => {
    const completed = req.readyState === 4 && req.status === 200 
    if (!completed) return
    switch (browser.name) {
      case 'Microsoft Edge':
      case 'Internet Explorer':
        const blob = new Blob([req.response], { type: 'application/pdf' })
        window.navigator.msSaveBlob(blob, filename)
        break
      case 'Chrome':
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(req.response)
        link.download = filename
        link.click()
        break
      default:
        var file = new File([req.response], filename, { type: 'application/force-download' })
        window.open(URL.createObjectURL(file))
    }
  }
  req.send(JSON.stringify({filename, html}))
}

export function createPost(context, name, options = {}) {
  return create(context, name, { method: 'POST', ...options})
}

export function createPublic (name, options) {
  return create('public', name, options)
}


export function mapParameters (command, map) {
  return (...parameters) => command(map(...parameters))
}

export function createDelayed (context, name, delay = 800, options) {
  let timeout
  const command = create(context, name, options)
  return (parameters) => new Promise (resolve => {
    const execute = () => command(parameters).then(resolve) 
    clearTimeout(timeout)
    timeout = setTimeout(execute, delay)
  })
}

export default function create(context, name, options = {}) {

  const {
    method = 'GET',
    sendAsArgs = false,
    protocol = apiProtocol, 
    server = subdomainResource(apiHost),
    mapParameters = a => a,
    mapResponse = a => a 
  } = options

  const commandUrl = context
    ? `${protocol}://${server}/${context}/${name}`
    : `${protocol}://${server}/${name}`

  const language = location.hash.substring(2,4)
  const requestOptions = {
    method: method,
    cache: 'no-store',
    headers: new Headers({
      'Content-Type': 'application/json',
      'Accept-Language': language
    }),
    mode: 'cors',
    redirect: 'follow',
    credentials: 'include',
  }

  return async (args) => {
      const parameters = mapParameters(args)
      const url = (method == 'GET' || sendAsArgs) && parameters
        ? `${commandUrl}?${queryString.stringify(parameters)}`
        : commandUrl
      let settings = requestOptions
      if (method != 'GET' && parameters) {
        settings = {...requestOptions, body: JSON.stringify(parameters)}
      }
      const response = await fetch(url, settings)
      if (response.ok) {
        if (response.status != 200) return true
        const contentType = /^(.*?)(;|$)/.exec(response.headers.get('content-type'))[1]
        switch (contentType) {
          case 'application/json': return mapResponse(await response.json())
          default: return true
        }
      }
      else throw(response)
  };
}
